// extracted by mini-css-extract-plugin
export default {"rating":"yy-z","numberOfStars":"zy-z","count":"Ay-z","barGraphSpacing":"By-z","barGraph":"Cy-z"};